module.exports = __webpack_public_path__ + "img/video.d52765b5.gif";